import classNames from 'classnames';
import { FC } from 'react';
import { ButtonVariants } from '../Button.types';
import styles from './LoadingSpinner.module.css';
import { LoadingSpinnerProps } from './LoadingSpinner.types';

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ variant, className }) =>
  variant === ButtonVariants.Primary ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={classNames(styles.loading, className)}
      data-testid="primary-loading-spinner"
    >
      <circle
        cx="10"
        cy="10"
        r="7"
        fill="none"
        stroke="#E21216"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="30 20"
        strokeDashoffset="0"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={classNames(styles.loading, className)}
      data-testid="secondary-loading-spinner"
    >
      <circle
        cx="10"
        cy="10"
        r="7"
        fill="none"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="30 20"
        strokeDashoffset="0"
      />
    </svg>
  );

export default LoadingSpinner;
